import { 
    Coupon, 
    CreateCouponDto, 
    UpdateCouponDto, 
    CouponValidationRequest, 
    CouponValidationResult,
    CouponStats,
    CouponCheckResponse
} from "../../types/coupon.types";
import apiService from "../api/api.service";

class CouponService {
    private static instance: CouponService;

    private constructor() {}

    public static getInstance(): CouponService {
        if (!CouponService.instance) {
            CouponService.instance = new CouponService();
        }
        return CouponService.instance;
    }

    // SuperAdmin only methods
    public async createCoupon(dto: CreateCouponDto): Promise<Coupon> {
        const response = await apiService.post<Coupon>("/coupons", dto);
        return response;
    }

    public async getAllCoupons(): Promise<Coupon[]> {
        const response = await apiService.get<Coupon[]>("/coupons");
        return response;
    }

    public async getCoupon(id: number): Promise<Coupon> {
        const response = await apiService.get<Coupon>(`/coupons/${id}`);
        return response;
    }

    public async updateCoupon(id: number, dto: UpdateCouponDto): Promise<Coupon> {
        const response = await apiService.put<Coupon>(`/coupons/${id}`, dto);
        return response;
    }

    public async deleteCoupon(id: number): Promise<void> {
        await apiService.delete<void>(`/coupons/${id}`);
    }

    public async toggleCouponStatus(id: number): Promise<Coupon> {
        const response = await apiService.patch<Coupon>(`/coupons/${id}/toggle-status`);
        return response;
    }

    public async getCouponStats(id: number): Promise<CouponStats> {
        const response = await apiService.get<CouponStats>(`/coupons/${id}/stats`);
        return response;
    }

    // Public methods
    public async validateCoupon(dto: CouponValidationRequest): Promise<CouponValidationResult> {
        const response = await apiService.post<CouponValidationResult>("/coupons/validate", dto);
        return response;
    }

    public async checkCouponCode(code: string): Promise<CouponCheckResponse> {
        const response = await apiService.get<CouponCheckResponse>(`/coupons/check/${code}`);
        return response;
    }
}

export default CouponService.getInstance();
